var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28173 0.75C6.73928 0.75 6.29956 1.18972 6.29956 1.73216V3.69643H8.26383V1.73216C8.26383 1.18972 7.82411 0.75 7.28173 0.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0317 0.75C20.4893 0.75 20.0496 1.18972 20.0496 1.73216V3.69643H22.0138V1.73216C22.0139 1.18972 21.5742 0.75 21.0317 0.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9603 3.69629H22.0139V7.62488C22.0139 8.16732 21.5742 8.60704 21.0317 8.60704C20.4893 8.60704 20.0496 8.16732 20.0496 7.62488V3.69629H8.26386V7.62488C8.26386 8.16732 7.82414 8.60704 7.2817 8.60704C6.73925 8.60704 6.29953 8.16732 6.29953 7.62488V3.69629H3.35316C1.7259 3.69629 0.406738 5.01545 0.406738 6.64272V25.3034C0.406738 26.9307 1.7259 28.2499 3.35316 28.2499H24.9603C26.5876 28.2499 27.9067 26.9307 27.9067 25.3034V6.64272C27.9067 5.01545 26.5876 3.69629 24.9603 3.69629ZM25.9424 25.3034C25.9424 25.8459 25.5027 26.2856 24.9603 26.2856H3.35316C2.81072 26.2856 2.371 25.8459 2.371 25.3034V12.5356H25.9424V25.3034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26381 14.5H6.29955C5.7571 14.5 5.31738 14.9397 5.31738 15.4822C5.31738 16.0246 5.7571 16.4643 6.29955 16.4643H8.26381C8.80626 16.4643 9.24598 16.0246 9.24598 15.4822C9.24598 14.9397 8.80626 14.5 8.26381 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1389 14.5H13.1746C12.6322 14.5 12.1924 14.9397 12.1924 15.4822C12.1924 16.0246 12.6322 16.4643 13.1746 16.4643H15.1389C15.6813 16.4643 16.121 16.0246 16.121 15.4822C16.121 14.9397 15.6813 14.5 15.1389 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0139 14.5H20.0497C19.5072 14.5 19.0675 14.9397 19.0675 15.4822C19.0675 16.0246 19.5072 16.4643 20.0497 16.4643H22.0139C22.5564 16.4643 22.9961 16.0246 22.9961 15.4822C22.9961 14.9397 22.5563 14.5 22.0139 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26381 18.4287H6.29955C5.7571 18.4287 5.31738 18.8684 5.31738 19.4109C5.31738 19.9533 5.7571 20.393 6.29955 20.393H8.26381C8.80626 20.393 9.24598 19.9533 9.24598 19.4109C9.24598 18.8684 8.80626 18.4287 8.26381 18.4287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1389 18.4287H13.1746C12.6322 18.4287 12.1924 18.8684 12.1924 19.4109C12.1924 19.9533 12.6322 20.393 13.1746 20.393H15.1389C15.6813 20.393 16.121 19.9533 16.121 19.4109C16.121 18.8684 15.6813 18.4287 15.1389 18.4287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0139 18.4287H20.0497C19.5072 18.4287 19.0675 18.8684 19.0675 19.4109C19.0675 19.9533 19.5072 20.393 20.0497 20.393H22.0139C22.5564 20.393 22.9961 19.9533 22.9961 19.4109C22.996 18.8684 22.5563 18.4287 22.0139 18.4287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26381 22.3569H6.29955C5.7571 22.3569 5.31738 22.7967 5.31738 23.3391C5.31738 23.8815 5.7571 24.3212 6.29955 24.3212H8.26381C8.80626 24.3212 9.24598 23.8815 9.24598 23.339C9.24598 22.7966 8.80626 22.3569 8.26381 22.3569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1389 22.3569H13.1746C12.6322 22.3569 12.1924 22.7967 12.1924 23.3391C12.1924 23.8815 12.6322 24.3213 13.1746 24.3213H15.1389C15.6813 24.3213 16.121 23.8815 16.121 23.3391C16.121 22.7967 15.6813 22.3569 15.1389 22.3569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0139 22.3569H20.0497C19.5072 22.3569 19.0675 22.7967 19.0675 23.3391C19.0675 23.8815 19.5072 24.3213 20.0497 24.3213H22.0139C22.5564 24.3213 22.9961 23.8815 22.9961 23.3391C22.9961 22.7967 22.5563 22.3569 22.0139 22.3569Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    transform: "translate(0.406738 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar1);
export default __webpack_public_path__ + "static/media/calendar1.2773f9d92829f81f589ab124d25aa5cf.svg";
export { ForwardRef as ReactComponent };